<script>

export default {
    emits: ['deleted'],

    props: {
        'url': {type: String},
        'content': {type: String},
        'icon': {type: Boolean, default: false},
        'small': {type: Boolean, default: false},
    },

    data() {
        return {
            isOpened: false,
            loading: false,
            controller: new AbortController(),
        }
    },

    methods: {
        cancel() {
            this.controller.abort();
            this.isOpened = false;
            this.$modal.close();
        },
        open() {
            this.$modal.open();
            this.isOpened = true;
        },
        submit() {
            this.loading = true;
            axios.delete(this.url).then(() => {
                this.isOpened = false;
                this.$modal.close();
                this.$emit('deleted');
            }).catch(()=>{}).finally(() => {
                this.loading = false;
            })
        },
        beforeUnmount() {
            this.controller.abort();
        }
    }
};
</script>

<template>
    <button class="button is-danger" v-bind:class="{'is-small': small}" @click.prevent="open()" :title="$t('actions.delete')">
        <b-icon v-if="icon" icon="trash-can-outline" size="is-small"/>
        <span v-if="!icon">{{ $t('actions.delete') }}</span>
    </button>
    <section v-if="isOpened">
        <div class="modal delete-modal" v-bind:class="{ 'is-active': isOpened }">
            <div class="modal-background"></div>
            <div class="modal-card">
                <section class="modal-card-body">
                    {{ content }}
                </section>
                <footer class="modal-card-foot">
                    <div class="buttons">
                        <button @click="submit()" v-bind:disabled="loading"
                                v-bind:class="{'is-loading': loading}" class="button is-danger">
                            {{ $t('labels.yes') }}
                        </button>
                        <button @click="cancel()" class="button">
                            {{ $t('actions.cancel') }}
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </section>
</template>
